import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ForwardIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Forward",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.2 14.28h14.93l-3.54-3.54c-.62-.74-.52-1.85.22-2.46.31-.26.71-.4 1.12-.41.41 0 .81.15 1.13.41l6.4 6.4c.34.33.53.77.54 1.24 0 .46-.18.91-.51 1.24l-6.4 6.4c-.68.68-1.8.68-2.48 0s-.68-1.8 0-2.48L24 17.59H9.2c-2.15 0-3.89 1.74-3.89 3.89v1.11c-.07.87-.8 1.54-1.67 1.54-.86 0-1.58-.67-1.64-1.53v-1.12a7.22 7.22 0 0 1 7.19-7.2z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M3 27.71c-.63 0-1.14-.51-1.14-1.14v-5.71c0-4.41 3.59-8 8-8h18.29a1.14 1.14 0 1 1 0 2.28H9.86c-3.15 0-5.71 2.56-5.71 5.71v5.71c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.14 23.14c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62L26.52 14l-7.19-7.19c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l8 8c.45.45.45 1.17 0 1.62l-8 8c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
ForwardIcon.displayName = 'ForwardIcon';